import React from 'react';
import { MapPin, Building2, Map } from 'lucide-react';

export default function LocationSelect({ onSelect }) {
  return (
    <div style={{
      minHeight: '100vh', background: '#f8f9fa',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 20,
    }}>
      <div style={{ maxWidth: 520, width: '100%', textAlign: 'center' }}>
        <div style={{
          width: 64, height: 64, borderRadius: '50%', background: 'var(--primary)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 24px',
        }}>
          <MapPin size={32} color="white" />
        </div>

        <h1 style={{ fontSize: 28, fontWeight: 800, color: 'var(--dark)', marginBottom: 8 }}>
          Where are you buying?
        </h1>
        <p style={{ color: 'var(--gray-500)', fontSize: 15, marginBottom: 36, lineHeight: 1.6 }}>
          We'll tailor your experience with local pricing, inspection tips, and closing cost details specific to your area.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <button onClick={() => onSelect('ottawa')} style={{
            display: 'flex', alignItems: 'center', gap: 16,
            padding: '20px 24px', background: 'white', border: '2px solid #e2e5e9',
            borderRadius: 12, cursor: 'pointer', textAlign: 'left',
            transition: 'all 0.2s',
            width: '100%',
          }}
          onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--primary)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(232,151,44,0.15)'; }}
          onMouseLeave={e => { e.currentTarget.style.borderColor = '#e2e5e9'; e.currentTarget.style.boxShadow = 'none'; }}
          >
            <div style={{
              width: 48, height: 48, borderRadius: 12, background: '#fff3e0',
              display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
            }}>
              <Building2 size={24} color="var(--primary)" />
            </div>
            <div>
              <div style={{ fontWeight: 700, fontSize: 17, color: 'var(--dark)', marginBottom: 4 }}>
                Ottawa, Ontario
              </div>
              <div style={{ fontSize: 13, color: 'var(--gray-500)', lineHeight: 1.4 }}>
                Ottawa-specific pricing, winter inspection tips, Hydro Ottawa setup, and local neighbourhood insights
              </div>
            </div>
          </button>

          <button onClick={() => onSelect('general')} style={{
            display: 'flex', alignItems: 'center', gap: 16,
            padding: '20px 24px', background: 'white', border: '2px solid #e2e5e9',
            borderRadius: 12, cursor: 'pointer', textAlign: 'left',
            transition: 'all 0.2s',
            width: '100%',
          }}
          onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--primary)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(232,151,44,0.15)'; }}
          onMouseLeave={e => { e.currentTarget.style.borderColor = '#e2e5e9'; e.currentTarget.style.boxShadow = 'none'; }}
          >
            <div style={{
              width: 48, height: 48, borderRadius: 12, background: '#e8f5e9',
              display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
            }}>
              <Map size={24} color="var(--green)" />
            </div>
            <div>
              <div style={{ fontWeight: 700, fontSize: 17, color: 'var(--dark)', marginBottom: 4 }}>
                Somewhere else in Ontario
              </div>
              <div style={{ fontSize: 13, color: 'var(--gray-500)', lineHeight: 1.4 }}>
                General Ontario home-buying guide with land transfer tax calculations and province-wide tips
              </div>
            </div>
          </button>
        </div>

        <p style={{ color: 'var(--gray-400)', fontSize: 13, marginTop: 24 }}>
          You can change this later in Settings.
        </p>
      </div>
    </div>
  );
}
